import { createFileRoute, redirect } from "@tanstack/react-router";
import { CampaignsTableEnhanced } from "@/app/partner/pages/campaigns/CampaignsTableEnhanced";
import { canAccessRoute } from "@/lib/auth";

export const Route = createFileRoute("/flex/dashboard/campaigns/")({
	beforeLoad: async ({ context }) => {
		const { partner } = context;
		const access = canAccessRoute(partner, "campaigns");

		if (!access.allowed) {
			throw redirect({ to: "/flex/dashboard" });
		}
	},
	component: CampaignsTableEnhanced,
});
